import React from "react";
import { Navigate } from "react-router-dom";
import { useSelector } from "react-redux";
import Login from "../Screens/Login";

const AuthCheckRoute = () => {
  const user = useSelector((state) => state?.user?.userDetails);
  console.log("auth check user runned: ", user);
  
  const isAuthenticated = user && user?.UserDetails?.email; // Ensure this matches your state's structure
  const isSalesUser = user && user?.UserDetails?.role === "Sales User";
  
  if (!isAuthenticated) {
    return <Login />;
  }
  
  if (isSalesUser) {
    return <Navigate to="/smartview" replace />;
  } else {
    return <Navigate to="/dashboard" replace />;
  }
};

export default AuthCheckRoute;